import { getApiUrl } from "@/config/runtime-env";

const API_BASE_URL = getApiUrl();

export const API_ENDPOINTS = {
  AUTH: {
    // Phone authentication (commented for future use)
    SEND_OTP: `${API_BASE_URL}/auth/send-otp`,
    VERIFY_OTP: `${API_BASE_URL}/auth/verify-otp`,
    // Email authentication (active)
    SEND_EMAIL_OTP: `${API_BASE_URL}/auth/send-email-otp`,
    VERIFY_EMAIL_OTP: `${API_BASE_URL}/auth/verify-email-otp`,
    REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh-token`,
    PROFILE: `${API_BASE_URL}/auth/profile`,
  },
  // Calendar endpoints - use relative paths (api.ts adds base URL)
  CALENDAR: {
    EVENTS: `/calendar/events`,
    GET: (id: string) => `/calendar/events/${id}`,
    CREATE: `/calendar/events`,
    UPDATE: (id: string) => `/calendar/events/${id}`,
    DELETE: (id: string) => `/calendar/events/${id}`,
    EVENT_SUBSCRIPTIONS: (id: string) => `/calendar/events/${id}/subscriptions`,
  },
} as const;
